import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import {Observable} from "rxjs";
import {GroupSessionTopics} from "./group-session-topics.model";

@Injectable({
  providedIn: 'root'
})
export class GroupSessionTopicsService {
  private collection = this.firestore.collection<GroupSessionTopics>('groupSessionTopics');

  constructor(private firestore: AngularFirestore) {}

  create(data: GroupSessionTopics): Promise<any> {
    const payload: GroupSessionTopics = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  getDataById(id: string): Observable<GroupSessionTopics | undefined> {
    return this.collection.doc<GroupSessionTopics>(id).valueChanges({ idField: 'id' });
  }

  getAll(): Observable<GroupSessionTopics[]> {
    return this.firestore.collection<GroupSessionTopics>('groupSessionTopics', ref =>
      ref.orderBy('sr', 'asc')
    ).valueChanges({ idField: 'id' });
  }
  update(id: string, data: Partial<GroupSessionTopics>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
